<form [formGroup]="configurationFormEmail">
  <div class="form-row row" [hidden]="!emailSettings.length">
    <div class="form-group col-xl-4 col-lg-6">
      <label for="transferType" class="control-label required">{{'i18n.domain.import-configuration.edit.email.mailbox' | translate}}</label>
      <ejs-dropdownlist [dataSource]="emailSettings"
                        [fields]="dropdownSettings"
                        id="ic-emailAccountId"
                        formControlName="emailAccountId">
      </ejs-dropdownlist>
      <app-error-messages [control]="configurationFormEmail.controls.emailAccountId"></app-error-messages>
    </div>
    <div class="form-group col-xl-4 col-lg-6">
      <label for="ic-mandatorySubjectContent" class="control-label">{{ 'i18n.domain.import-configuration.edit.email.mandatory-subject-content' | translate }}</label>
      <input id="ic-mandatorySubjectContent" type="text" class="form-control" formControlName="mandatorySubjectContent" />
      <app-error-messages [control]="configurationFormEmail.controls.mandatorySubjectContent"></app-error-messages>
    </div>
    <div class="form-group col-xl-4 col-lg-6">
      <label for="ic-mandatoryBodyContent" class="control-label">{{ 'i18n.domain.import-configuration.edit.email.mandatory-body-content' | translate }}</label>
      <input id="ic-mandatoryBodyContent" type="text" class="form-control" formControlName="mandatoryBodyContent" />
      <app-error-messages [control]="configurationFormEmail.controls.mandatoryBodyContent"></app-error-messages>
    </div>
    <div class="form-group col-xl-4 col-lg-6">
      <label for="ic-senderEmailAddress" class="control-label">{{ 'i18n.domain.import-configuration.edit.email.sender-email-address' | translate }}</label>
      <ejs-tooltip id='ic-tooltip' content="{{ 'i18n.domain.import-configuration.edit.email.sender-email-address-tip' | translate }}">
        <span class="icon-information px-1"></span>
      </ejs-tooltip>
      <input id="ic-senderEmailAddress" type="text" class="form-control" formControlName="senderEmailAddress" />
      <app-error-messages [control]="configurationFormEmail.controls.senderEmailAddress"></app-error-messages>
    </div>
  </div>
  <div class="form-row row" [hidden]="emailSettings.length">
    <div class="form-group col-12">
      <p>{{'i18n.domain.import-configuration.edit.email.no-mailbox'| translate }}</p>
    </div>
  </div>
</form>
